import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import EventService from "../services/event.services";
import CommonService from "../services/common.service";
import LeaveHistoryService from "../services/leaveHistory.service";
import AuthService from "../services/auth.service";

const StateContext = createContext();

export const ContextProvider = ({ children }) => {
  const [showCalendar, setShowCalendar] = useState(false);

  const [showMenu, setShowMenu] = useState(false);

  const [sortBy, setSortBy] = useState(false);
  const [filterBy, setFilterBy] = useState(false);

  const [applyLeaveModal, setApplyLeaveModal] = useState(false);
  const [editLeaveModal, setEditLeaveModal] = useState(false);
  const [deleteLeaveModal, setDeleteLeaveModal] = useState(false);

  const [editTime, setEditTime] = useState(false);
  const [success, setSuccess] = useState(false);

  const [event, setEvent] = useState(false);

  const [sendWish, setSendWish] = useState(false);

  const [feedback, setFeedback] = useState(false);

  const [policy, setPolicy] = useState(false);

  const [applyWorkModeModal, setApplyWorkModeModal] = useState(false);

  const [approveModal, setApproveModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);

  const [selectedDate, onChange] = useState(new Date());

  const [windowHeight, setWindowHeight] = useState("");

  const [events, setEvents] = useState([]);

  const [employees, setEmployees] = useState([]);

  const [locations, setLocations] = useState([]);

  const fetchLocations = useCallback(() => {
    CommonService.getAllLocations()
      .then((resp) => {
        const locationsData = resp.data.map((item) => ({
          label: item.location,
          value: item.location,
        }));
        const allLoc = [
          {
            label: "All",
            value: "all",
          },
        ];
        const locationsDataNew = allLoc.concat(locationsData);
        setLocations(locationsDataNew);
      })
      .catch((e) => console.log(e));
  }, []);

  useEffect(() => {
    fetchLocations();
  }, [fetchLocations]);

  const generateRandomHexColor = () => {
    const randomColor = "#" + Math.floor(Math.random() * 16777215).toString(16);
    return randomColor;
  };

  const convertDate = (dateString) => {
    const [day, month, year] = dateString.split("-");
    return `${year}-${month}-${day}`;
  };

  const fetchAllEvents = useCallback(() => {
    EventService.getAllEvents()
      .then((resp) => {
        const eventsData = resp.data.map((item) => ({
          title: item.subject,
          name: item.name,
          empId: item.employee,
          profile: item.profile,
          date: convertDate(item.date.split(" ")[0]),
          // date: moment(new Date(item.date.split(" ")[0])).format("YYYY-MM-DD"),
          color: generateRandomHexColor(),
        }));

        // console.log(eventsData);

        setEvents(eventsData);
      })
      .catch((e) => console.log(e));
  }, []);

  useEffect(() => {
    fetchAllEvents();
  }, [fetchAllEvents]);

  const fetchAllEmployees = useCallback(() => {
    const payload = {
      empId: "",
    };
    LeaveHistoryService.getEmpInfo(payload)
      .then((resp) => {
        setEmployees(resp.data);
      })
      .catch((e) => console.log(e));
  }, []);

  useEffect(() => {
    const user = AuthService.getCurrentUser();
    if (user && user.role !== "3") {
      fetchAllEmployees();
    }
  }, [fetchAllEmployees]);

  const getNameInitials = (userName) => {
    try {
      if (typeof userName !== "string") return "";

      const parts = userName.trim().split(/\s+/);

      if (parts.length === 0 || parts[0] === "") return "";

      const firstName = parts[0];
      const lastName = parts.length > 1 ? parts[parts.length - 1] : "";

      const firstLetter = firstName.charAt(0).toUpperCase();
      const lastLetter = lastName ? lastName.charAt(0).toUpperCase() : "";

      return firstLetter + lastLetter;
    } catch (error) {
      console.error("Invalid username:", error);
      return "";
    }
  };

  return (
    <StateContext.Provider
      value={{
        showMenu,
        setShowMenu,
        showCalendar,
        setShowCalendar,
        sortBy,
        setSortBy,
        filterBy,
        setFilterBy,
        applyLeaveModal,
        setApplyLeaveModal,
        selectedDate,
        onChange,
        editLeaveModal,
        setEditLeaveModal,
        deleteLeaveModal,
        setDeleteLeaveModal,
        editTime,
        setEditTime,
        success,
        setSuccess,
        event,
        setEvent,
        sendWish,
        setSendWish,
        feedback,
        setFeedback,
        applyWorkModeModal,
        setApplyWorkModeModal,
        approveModal,
        setApproveModal,
        rejectModal,
        setRejectModal,
        windowHeight,
        setWindowHeight,
        policy,
        setPolicy,
        events,
        setEvents,
        fetchAllEvents,
        employees,
        setEmployees,
        locations,
        getNameInitials
      }}
    >
      {children}
    </StateContext.Provider>
  );
};

export const useStateContext = () => useContext(StateContext);
